import { MiTHEME } from "@miplatform/theme";
import { IStatusDisplayConfig } from "@miplatform/types";

export const PASSED = "Passed";
export const FAILED = "Failed";
export const READY = "Ready";
export const SCHEDULED = "Scheduled";
export const RESCHEDULED = "Rescheduled";
export const LATE = "Late";
export const EARLY = "Early";

export const inspectionIsComplete = (status: string) => {
  return status === PASSED || status === FAILED;
};

export const INSPECTION_STATUS_CONFIG: Record<string, IStatusDisplayConfig> = {
  [LATE]: {
    color: MiTHEME.palette.red.accent,
    backgroundColor: MiTHEME.palette.red.light,
    label: LATE,
  },
  [EARLY]: {
    color: MiTHEME.palette.teal.main,
    backgroundColor: MiTHEME.palette.teal.light,
    label: EARLY,
  },
  [READY]: {
    color: MiTHEME.palette.amber.main,
    backgroundColor: MiTHEME.palette.amber.light,
    label: READY,
  },
  [PASSED]: {
    color: MiTHEME.palette.green.main,
    backgroundColor: MiTHEME.palette.green.light,
    label: PASSED,
  },
  [FAILED]: {
    color: MiTHEME.palette.red.main,
    backgroundColor: MiTHEME.palette.red.light,
    label: FAILED,
  },
  [SCHEDULED]: {
    color: MiTHEME.palette.blue.main,
    backgroundColor: MiTHEME.palette.blue.light,
    label: SCHEDULED,
  },
};
